import React from "react"
import { view } from "react-easy-state"
import { Form, Input, Button, Checkbox, Select } from "antd"

import globalStore from "store"
import UsersService from "services/users.service"
import { message } from "../../../../../../node_modules/antd/lib/index"

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 18 },
  },
}

class ProfileEditForm extends React.Component {
  state = {
    profileUpdating: false,
  }

  handleSubmit = (e) => {
    e.preventDefault()
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        this.setState({ profileUpdating: true })

        const pageState = globalStore.ui.users.edit
        await UsersService.edit({ pageState, values })

        this.setState({ profileUpdating: false })

        const { user, userErrors } = pageState

        if (userErrors) {
          message.detroy()
          message.error(userErrors)
          return
        }
        const { schools } = globalStore.ui.students.schools.index

        globalStore.ui.users.show = {
          ...globalStore.ui.users.show,
          user: {
            ...user,
            school: schools.filter((s) => s.id === values.school_id)[0],
          },
        }
        message.destroy()
        message.success("Profile details are updated successfully!")
        this.props.discardForm()
        return
      }
    })
  }

  render() {
    const { profileUpdating } = this.state
    const { form, user } = this.props
    const { getFieldDecorator } = form

    const { schools } = globalStore.ui.students.schools.index

    return (
      <div className="basic-info">
        <Form
          {...formItemLayout}
          onSubmit={this.handleSubmit}
          style={{ maxWidth: "550px" }}
        >
          <Form.Item label="Name">
            {getFieldDecorator("name", {
              rules: [
                {
                  required: false,
                  message: "Name can't be blank",
                },
              ],
              initialValue: user.name || null,
            })(<Input placeholder={"Enter your name"} />)}
          </Form.Item>
          <Form.Item label="Email">
            <Input value={user.email} disabled />
          </Form.Item>
          <Form.Item label="Phone Number" style={{ marginBottom: 0 }}>
            {getFieldDecorator("phone", {
              rules: [
                {
                  required: false,
                  message: "Phone number can't be blank",
                },
              ],
              initialValue: user.phone || null,
            })(<Input placeholder={"Enter phone number"} />)}
          </Form.Item>
          <Form.Item label="Parent's Phone">
            {getFieldDecorator(
              "parents_phone",
              {}
            )(
              <Checkbox defaultChecked={user.parents_phone}>
                This is my parent's phone
              </Checkbox>
            )}
          </Form.Item>
          <Form.Item label="School">
            {getFieldDecorator("school_id", {
              rules: [],
              initialValue: (user.school && user.school.id) || null,
            })(
              <Select
                showSearch
                placeholder="Select your school"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {schools.map((s) => (
                  <Select.Option value={s.id}>{s.name}</Select.Option>
                ))}
              </Select>
            )}
          </Form.Item>
          <div style={{ textAlign: "right" }}>
            <Button
              style={{ marginRight: 10 }}
              onClick={this.props.discardForm}
              disabled={profileUpdating}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              onClick={this.handleSubmit}
              loading={profileUpdating}
            >
              Update
            </Button>
          </div>
        </Form>
      </div>
    )
  }
}

ProfileEditForm = Form.create({ name: "profile-edit" })(ProfileEditForm)

export default view(ProfileEditForm)
